/**
 * PersonList section
 */
(function($, window) {


    $(document).on('cms.ready', ready);
    // $(document).ready(ready);
    // $(document).on('sectionPersonList.ready', ready);
    //
    // var $template,
    //     $section,
    //     $person_list;

    /* Initial building of the person-list */
    function ready() {
        let $sections = $('.sectionPersonList');
        $sections.each(initializeSection);
    }

    function initializeSection(idx, elm) {
        let $section = $(elm),
            $person_list = $('.person-list__grid', $section),
            $template = $('.person-list-section-template', $section).detach();

        var ids = [],
            $children = $person_list.children('.person-list__person');
        $children.each(function(idx, elm) {
            ids.push($(elm).data('person-id'));
        });

        $.get(
            'api/person/idlist',
            { personIds: ids },
            function(data) {
                $.each(data.rows, function(i, person) {
                    var $child = $person_list.find('[data-person-id='+person.id+']');

                    var $memberTemplate = $template.clone();
                    $memberTemplate.removeClass('person-list-section-template');

                    for(var key in person) {
                        var value = person[key];
                        setValue($memberTemplate, key, value);
                    }
                    setEmailField(person, $memberTemplate);

                    // $memberTemplate.appendTo($child);
                    $memberTemplate.children().appendTo($child);
                    // $memberTemplate.children().unwrap();
                });

                // Deal with dummy items
                var $nonitems = $person_list.find('[data-person-id="-1"]');
                $nonitems.each(function(idx, elm) {
                    var $memberTemplate = $template.clone();
                    $memberTemplate.removeClass('person-list-section-template');
                    // $memberTemplate.appendTo(elm);
                    $memberTemplate.children().appendTo(elm);
                    // $memberTemplate.children().unwrap();
                });

                $section.trigger('sectionPersonList.frontend.ready');
                // $section.trigger('widgetImages.update');
            }
        );

        $(document).on('sectionPersonList.addItem', addDummyItem);

        $(document).on('sectionPersonList.removeItem', function removeItem(e, obj) {
            // console.log('remove item', e, obj);
            $section.trigger('sectionPersonList.frontend.update');
        });

        $(document).on('sectionPersonList.updateItem', function(e, obj) {
            var item = obj.item,
                idx = obj.idx;
            var $child = $person_list.children().eq(idx);

            if(!item.id) return addDummyItem(e, idx);

            $child.empty(); // Remove old content
            $.get(
                'api/person/' + item.id,
                function(person) {
                    var $memberTemplate = $template.clone();
                    $memberTemplate.removeClass('person-list-section-template');

                    for(var key in person) {
                        var value = person[key];
                        setValue($memberTemplate, key, value);
                    }
                    setEmailField(person, $memberTemplate);

                    // $memberTemplate.appendTo($child); // Add new content
                    $memberTemplate.children().appendTo($child);

                    $section.trigger('sectionPersonList.frontend.update');
                }
            );
        });


        function addDummyItem(e, idx) {
            var $child = $person_list.children().eq(idx);
            $child.empty(); // Remove existing content

            var $memberTemplate = $template.clone();
            $memberTemplate.removeClass('person-list-section-template');

            var person = {
                'name': 'Name',
                'email': 'e@mail.com',
                // 'position':'Title',
                'description':'Description',
                'phone': '00000000',
                'image': 'https://picsum.photos/300/400'
            };
            for(var key in person) {
                var value = person[key];
                setValue($memberTemplate, key, value);
            }

            $memberTemplate.children().appendTo($child);

            $section.trigger('sectionPersonList.frontend.update');
        }
    };


    function setValue($memberTemplate, key, value) {
        if($.isArray(value)) {
            for(var _key in value) {
                setValue($memberTemplate, key + '.' + _key, value[_key]);
            }
            return;
        }
        setTemplateValue($memberTemplate, key, value);
    }

    function setTemplateValue($memberTemplate, key, value) {
        if(typeof(value) === "undefined" || value == null || value == "") {
            return;
        }
        var elm = $memberTemplate.find('[data-field="' + key + '"]');

        switch(key) {
            case 'image':
                elm.css('backgroundImage', 'url("' + value + '?opt=true")')
                break;
            case 'email':
                elm.attr('href', 'mailto:'+value);
                elm.html('<i class="fas fa-envelope"></i>' + value);
                break;
            case 'phone':
                elm.attr('href', 'tel:'+value);
                elm.html('<i class="fas fa-phone"></i>' + value);
                break;
            default:
                elm.html(value);
                break;
        }
    }

    function setEmailField(person, $memberTemplate) {
        var elm = $memberTemplate.find('[data-field="email"]');

        if(person.email) {
            var value = person.email;
            if(person.email && person.name) {
                value = Contenda.t('Mail to') + ' ' +person.name.split(' ')[0];
            }
            elm.html('<i class="fas fa-envelope"></i>' + value);
        }
    }

})(jQuery, window);